var map = {
	"./agrarisch.svg": 3604,
	"./agrarisch_2.svg": 7363,
	"./agrarisch_3.svg": 2349,
	"./agrarisch_4.svg": 4501,
	"./basis.svg": 1958,
	"./bedrijven.svg": 5156,
	"./bedrijven_2.svg": 271,
	"./bedrijven_3.svg": 5341,
	"./bedrijven_4.svg": 2685,
	"./natuur.svg": 1287,
	"./natuur_2.svg": 7264,
	"./natuur_3.svg": 8259,
	"./openbaar.svg": 8741,
	"./openbaar_2.svg": 8365,
	"./pijl.svg": 4722,
	"./pijl_hover.svg": 7882,
	"./sport.svg": 8700,
	"./sport_2.svg": 5078,
	"./sport_3.svg": 5633,
	"./water.svg": 5453,
	"./water_2.svg": 5845,
	"./water_3.svg": 697,
	"./wbedrijven.svg": 9834,
	"./wbedrijven_2.svg": 1152,
	"./wbedrijven_3.svg": 1310,
	"./wbedrijven_4.svg": 181,
	"./wegen.svg": 8633,
	"./wonen.svg": 1017,
	"./wonen_2.svg": 1083,
	"./wonen_3.svg": 2620,
	"./wonen_4.svg": 7732,
	"./xagrarisch.svg": 8526,
	"./xagrarisch_2.svg": 6239,
	"./xagrarisch_3.svg": 6234,
	"./xagrarisch_4.svg": 4482,
	"./xnatuur.svg": 7143,
	"./xnatuur_2.svg": 6262,
	"./xnatuur_3.svg": 8782,
	"./xopenbaar.svg": 6638,
	"./xopenbaar_2.svg": 5731,
	"./xsport.svg": 1462,
	"./xsport_2.svg": 3565,
	"./xsport_3.svg": 1995,
	"./xwater.svg": 183,
	"./xwater_2.svg": 3340,
	"./xwater_3.svg": 9445,
	"./xwegen.svg": 5654,
	"./xwonen.svg": 4645,
	"./xwonen_2.svg": 4889,
	"./xwonen_3.svg": 3436,
	"./xwonen_4.svg": 260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;